<template>
  <div>
    <dig-tab @OnChangeTab=OnChangeTab style="padding:10px;" :items="[{title:title + ' List', icon:'fa fa-database'},{title:'Add ' + title, icon:'fa fa-plus'}]" :selectedIndex.sync="selectedTab">
      <dig-table @OnAddOn=OnAddOn v-if="selectedTab == 0" :items=list.data :isLoading=list.isLoading :hidden=listHidden :addOns=list.addOns></dig-table>
      <dig-form v-if="selectedTab == 1" :show-title-item=true :title="'New ' + title" :items="formData" :isLoading="form.isLoading" @OnSubmit="OnSubmit"></dig-form>
    </dig-tab>
    <dig-modal :isShowing.sync=details.isShowing :marginTop=15 :contentWidth="detailsWidth" @OnClose=OnCloseDetails>
      <dig-form ref=formDetail :show-title-item=true :title=details.title :items="formData" :isLoading=details.isLoading @OnSubmit="OnUpdate"></dig-form>
    </dig-modal>
    <dig-notif :text="notif.text" :show.sync="notif.show"></dig-notif>
  </div>
</template>

<script>
import Form from '../digilib_web/vue/form.vue'
import Table from '../digilib_web/vue/table.vue'
import Tab from '../digilib_web/vue/tab.vue'
import Modal from '../digilib_web/vue/modal.vue'
import Notif from '../digilib_web/vue/notif.vue'
import { Http } from '../digilib_web/core/digitify.js'

export default {
  components: {
    'dig-form' : Form,
		'dig-table' : Table,
    'dig-tab' : Tab,
    'dig-modal' : Modal,
    'dig-notif' : Notif,
  },
  mounted() {
    this.OnChangeTab(0);
  },
  props: {
    title: String,
    name: String,
    formData: Array,
    listHidden: Array,
    detailsWidth: Number
  },
  methods: {
    OnChangeTab: function(index) {
      if (index == 0) {
        this.list.isLoading = true;
        this.list.data = [];
        Http.Request(
          'GET', this.name + '/details',
          {
            OnResponse:function(json) {
              this.list.isLoading = false;
              this.list.data = json;
            }.bind(this)
          }
        );
      }
    },
    OnSubmit: function(data) {
      this.form.isLoading = true;
      Http.Request(
        'POST', this.name,
        {
          data : data,
          OnResponse:function(json) {
            this.form.isLoading = false;
            if (json.success) {
              this.selectedTab = 0;
              this.OnChangeTab(0);
              this.notif.text = json.msg;
              this.notif.show = true;
            } else {
              alert(json.msg);
            }
          }.bind(this)
        }
      );
    },
    OnUpdate: function(data) {
      this.details.isLoading = true;
      Http.Request(
        'PUT', this.name,
        {
          'data' : {id:this.details.id, 'data':data},
          OnResponse:function(json) {
            this.details.isLoading = false;
            if (json.success) {
              this.notif.text = json.msg;
              this.notif.show = true;
            } else {
              alert(json.msg);
            }
          }.bind(this)
        }
      );
    },
    OnCloseDetails: function() {
      this.OnChangeTab(0);
    },
    OnAddOn: function(tableIndex, index) {
      //details button
      if (index == 0) {
        var selectedList = this.list.data[tableIndex];
        this.details.title = 'Details';
        this.details.id = selectedList.id;
        this.details.isShowing = true;
        this.$refs.formDetail.SetValues(selectedList);
      }
      //delete
      else if (index == 1) {
        if (confirm('Are you sure you want to delete?')) {
          this.list.isLoading = true;
          Http.Request(
            'DELETE',
            this.name,
            {
              'data' : {id:this.list.data[tableIndex].id},
              OnResponse:function(json) {
                this.list.isLoading = false;
                if (json.success) {
                  this.notif.text = json.msg;
                  this.notif.show = true;
                  this.OnChangeTab(0);
                } else {
                  alert(json.msg);
                }
              }.bind(this)
            }
          );
        }
      }
    }
  },
  data() {
		return {
      selectedTab:0,
      list:{
        isLoading:false,
        data:[],
        addOns:[
          {text:'details', type:'details'},
          {text:'delete', type:'delete'}
        ]
      },
      form: {
        isLoading:false,
      },
      details: {
        title:'',
        id:null,
        isShowing:false,
        isLoading:false,
        selectedTab:0,
      },
      notif: {
        text:'',
        show:false,
      }
		}
	},
}
</script>
